export default "__VITE_ASSET__ac588024__"